import Responsive from './Responsive';
import Swiper from 'swiper';

module.exports = function() {
	const r = new Responsive();

	const slide__home_news_wrapper = $('.slide--home_news_wrapper');
	const slide__home_news_target = '#js-slide--home_news';
	let slide_home = undefined;
	let slides = $(slide__home_news_target).find('li').length;

	let slide__home_news_options = {
		speed:800,
		slidesPerView: 'auto',
		spaceBetween: 30,
		//loop:true,
		nextButton: '.swiper-button-next--news',
		prevButton: '.swiper-button-prev--news',
		centeredSlides:true,
		watchOverflow: true,
		//autoplay:2000
	};

	if(!r.state()()){
		slide__home_news_options.spaceBetween = 10;
	}

	$(window).on('load',function(){
	  new Swiper(slide__home_news_target,slide__home_news_options);
	});
}



// WEBPACK FOOTER //
// ./dev/js/scripts/home_news.js